var exports = {
  "k": "x43aef4ae--4833cc--container",
  "n": "x43aef4ae--4833cc--link",
};

module.exports = exports;
